module.exports = __webpack_public_path__ + "img/replay-button.2eb49182.png";